<template>
  <div>
    <a class="burger mx-4" v-if="totalRequestCount > 0" @click="showRequests">
        <span class="text-warning notification-badge">
          {{ totalRequestCount }} Sign up {{ totalRequestCount===1?`Request`:`Requests` }}
        </span>
      <font-awesome-icon icon="bell"/>
      <audio ref="audioPlayer" src="@/assets/notification.mp3"></audio>
    </a>
    <button id="requestBtn" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#requestsModal" style="display: none"></button>

    <!-- Modal -->
    <div class="modal fade" id="requestsModal" tabindex="-1" aria-labelledby="requestsModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="requestsModalLabel">Pending Sign up Requests</h1>
            <button type="button" class="btn-close" id="requestModalClose" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                {{ client }} <span class="text-info">Client</span> {{ client===1?`Request`:`Requests` }}
                <a @click="clientRequests" class="btn btn-sm btn-outline-primary float-end">View</a>
              </li>
              <li class="list-group-item">
                {{ agents }} <span class="text-success">Kazang Agent</span> {{ client===1?`Request`:`Requests` }}
                <a @click="agentRequests" class="btn btn-sm btn-outline-primary float-end">View</a>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RequestsPending",
  computed : {
    client(){
      return this.$store.getters.getClientRequestCount;
    },
    agents(){
      return this.$store.getters.getAgentRequestCount;
    },
    totalRequestCount() {
      return this.$store.getters.getTotalRequestCount;
    },
    pageName() {
      return this.$route.name;
    },
  },
  methods : {
    showRequests(){
      document.getElementById(`requestBtn`).click();
    },

    clientRequests(){
      if (this.pageName === `pending-requests`) {
        this.$utils.showLoading();
        return window.location.reload(true);
      }
      document.getElementById(`requestModalClose`).click();
      return this.$router.push({ name : `pending-requests` })
    },

    agentRequests(){
      if (this.pageName === `agent-requests`) {
        this.$utils.showLoading();
        return window.location.reload(true);
      }
      document.getElementById(`requestModalClose`).click();
      return this.$router.push({ name : `agent-requests` })
    },
    playNotificationSound(){
      this.$refs.audioPlayer.play();
    }
  },
}
</script>

<style scoped>
.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
}

.modal-backdrop {
  z-index: -2 !important;
}
</style>